import { createSelector } from "reselect"
import { get, chain, forEach, find } from "lodash"
import pluralize from "pluralize"
import { getFactorsMetadata } from "selectors/factors"
import { getModelCategories } from "selectors/modelMetadata"

const EMPTY_ARRAY = []

const getRawSelectedMetric = state => get(state, "modules.compareRisk.selectedMetric")
const getSavedMetric = (state, props) => get(props, "savedMetric")

const defaultMetric = "total"

function getCategory(category, factors) {
  if (category.singleFactor) {
    return {
      label: category.label,
      options: chain(factors)
        .pickBy(factor => factor.category === category.id)
        .map((factor, id) => ({
          label: factor.label,
          id,
          value: item => chain(item)
            .get("attribution.factors", EMPTY_ARRAY)
            .find(factor => factor.id === id)
            .get("value", 0)
            .value(),
        }))
        .value(),
    }
  } else {
    return {
      label: pluralize(category.label),
      options: [{
        label: `${category.label} Total`,
        id: `${category.id}_total`,
        value: item => chain(item)
          .get("attribution.factors", EMPTY_ARRAY)
          .filter(factor => factor.category === category.id)
          .sumBy("value")
          .value(),
      }, ...chain(factors)
        .pickBy(factor => factor.category === category.id)
        .map((factor, id) => ({
          label: factor.label,
          id,
          value: item => chain(item)
            .get("attribution.factors", EMPTY_ARRAY)
            .find(factor => factor.id === id)
            .get("value", 0)
            .value(),
        }))
        .value(),
      ],
    }
  }
}

export const getMetrics = createSelector(
  [getFactorsMetadata, getModelCategories],
  (factors, categories) => ([{
    label: "Risk",
    options: [{
      label: "Total",
      id: "total",
      value: item => get(item, "total"),
    }, {
      label: "Factors",
      id: "factors",
      value: item => get(item, "attribution.summary.factors"),
    }, {
      label: "Specific",
      id: "specific",
      value: item => get(item, "attribution.summary.specific"),
    }],
  }, ...chain(categories)
    .map(category => getCategory(category, factors))
    .value(),
  ]),
)

export const getSelectedMetric = createSelector(
  [getMetrics, getRawSelectedMetric, getSavedMetric],
  (metrics, selectedMetric, savedMetric) => {
    const metric = selectedMetric || savedMetric || defaultMetric
    let metricData, defaultMetricData = null

    forEach(metrics, item => {
      const data = find(item.options, { id: metric })

      if (data) {
        metricData = data
        return false
      }
      defaultMetricData = find(item.options, { id: defaultMetric }) || defaultMetricData
    })

    return metricData || defaultMetricData
  },
)
